import { PaymentVerificationTypes } from '../../../types/Cashier';

const usePaymentVerificationGuardsData = () => {
  const paymentVerificationMenuSelect = ({
    values: {
      paymentVerification: { menuSelected }
    }
  }: {
    values: { paymentVerification: { menuSelected: PaymentVerificationTypes } };
  }) => menuSelected === PaymentVerificationTypes.verify;

  return {
    paymentVerificationMenuSelect
  };
};

export default usePaymentVerificationGuardsData;
